const t = "Etapa concluída", o = "Voltar para {buttonName}", a = "Continuar para {buttonName}", n = {
  completedStep: t,
  backButton: o,
  nextButton: a
};
export {
  o as backButton,
  t as completedStep,
  n as default,
  a as nextButton
};
